import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule,
} from '@domain-group/suit-theme'

import CompatibleProductListItem from './CompatibleProductListItem'

const CompatibleProducts = (props) => {
  const { serviceProductPayload } = props
  const {
    callbacks: {
      addCompatibleProduct,
      toggleCompatibleProduct,
    },
    compatibleProductIds,
    loading,
  } = serviceProductPayload

  const hasCompatibleProducts = !!compatibleProductIds.length

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-compatible-products' }}
      title="Compatible Products"
      loading={loading}
    >
      <Box flexDirection="column">
        {!loading && !hasCompatibleProducts && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Compatible Products present.
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please assign a Product.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasCompatibleProducts && (
          <DashboardModule.ScrollableSection flexDirection="column">
            {compatibleProductIds.map(compatibleProductId => (
              <CompatibleProductListItem
                callbacks={{
                  toggleCompatibleProduct: () => toggleCompatibleProduct(compatibleProductId),
                }}
                compatibleProduct={{ id: compatibleProductId }}
                key={compatibleProductId}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.Footer boxProps={{ borderTop: loading ? 'none' : '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => addCompatibleProduct()}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Product
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

CompatibleProducts.propTypes = {
  serviceProductPayload: PropTypes.object.isRequired,
}

export default CompatibleProducts
